module.exports = __webpack_public_path__ + "img/home_icon.0a18080e.svg";